import type { ReactNode } from "react";
import { Outlet } from "react-router";
import Header from "./Header/Header";
import { withPageErrorBoundary } from "utils/errorHandling";
import { SDEAppsThemeProvider } from "providers";

function UnauthenticatedRoot(): ReactNode {
  return (
    <SDEAppsThemeProvider>
      <Header unAuthenticated />
      <Outlet />
    </SDEAppsThemeProvider>
  );
}

const UnauthenticatedRootWithErrorBoundary = withPageErrorBoundary(UnauthenticatedRoot);
export default UnauthenticatedRootWithErrorBoundary;
